// The hotspot prop (plan §1.7). A component spreads useHs(hs) onto the element the pointer targets (the button, link
// or input itself, never a wrapper). The attribute is emitted only in capture or demo mode, and only in a development
// or capture build, so a production page never carries a hotspot attribute.
//
// A hotspot is a number or a stable string key. A number is the frame's own hotspot and emits data-hotspot; a string
// key (`req.save`, two or more dot-separated segments) emits data-hs, and the capture harness stamps data-hotspot from
// the frame's own order, so one screen serves frames whose tours number its controls differently.

import { useMc } from "./McRoot";

export type Hs = number | string;

export type HsProps = { "data-hotspot"?: string; "data-hs"?: string };

const BUILD_ALLOWS = import.meta.env.DEV || import.meta.env.VITE_MC_CAPTURE === "true";

export function useHs(hs?: Hs | undefined): HsProps {
  const { capture, demo } = useMc();
  if (hs === undefined || !BUILD_ALLOWS || !(capture || demo)) return {};
  return typeof hs === "string" ? { "data-hs": hs } : { "data-hotspot": String(hs) };
}
